







































































































































import { Component, Vue } from "vue-property-decorator";
import QErrors from "@/common/qErrors.vue";
import StepCheckList from "@/components/contract-moving/step/stepCheckList.vue";
import ContractMoveOutHistory from "@/components/contract-moving/contractMoveOutHistory.vue";
import { namespace } from "vuex-class";
import ContractMoveOut, { CONTRACT_STEP } from "@/model/contractMoveOut";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import VueScrollTo from "vue-scrollto";
import qNotify from "@/common/qNotify";
import { USER_ROLE } from "@/model/user";
import Company from "@/model/company";
import QUserSelect from "@/common/qUserSelect.vue";
import QCalendar from "@/common/qCalendar.vue";

const moveOutStore = namespace("MoveOut");
const auth = namespace("Auth");
@Component({
  name: "StepCorrectCheckList",
  components: {
    StepCheckList,
    QErrors,
    ContractMoveOutHistory,
    QUserSelect,
    QCalendar,
  },
})
export default class StepCorrectCheckList extends Vue {
  @moveOutStore.Getter
  getMoveOut!: ContractMoveOut;
  @auth.Getter
  getCurrentyCompany!: Company;

  public moveOutObject: ContractMoveOut = new ContractMoveOut();
  public errors = {};
  public userRole = USER_ROLE;
  public dateConfig = {};
  public isShowPopup = false;

  mounted() {
    this.dateConfig = {
      minDate: new Date(),
    };
    this.moveOutObject = new ContractMoveOut(_.cloneDeep(this.getMoveOut));
    this.moveOutObject.request_repair_witness_id =
      this.moveOutObject.witness_id;
    if (!this.moveOutObject.request_repair_witness_in_charge_id) {
      this.moveOutObject.request_repair_witness_in_charge_id =
        this.moveOutObject.witness_owner_id;
    }
    if (!this.moveOutObject.request_repair_manage_in_charge_id) {
      this.moveOutObject.request_repair_manage_in_charge_id =
        this.moveOutObject.in_charge_id;
    }
  }
  get companyId() {
    return this.getCurrentyCompany.id;
  }
  get contractMoveOutId() {
    return this.$router.currentRoute.params.id;
  }

  public async rejectRequest() {
    this.$modal.showCancel({
      title: "依頼を却下する",
      text: `修繕依頼を却下します。この操作は取り消せません。`,
      confirmText: "はい",
      cancelText: "キャンセル",
      confirmClass: "mb__button mb__w-100pc mb__add-color-red",
      cancelClass: "mb__button mb__w-100pc mb__add-color-gray",
      type: "error",
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await this.moveOutObject.goBack({
          step: CONTRACT_STEP.STEP_COMPLETE_CHECK_LIST,
        });
        if (result.meta.status === 200) {
          this.$router.replace({ query: { step: uuidv4() } });
          VueScrollTo.scrollTo({ force: true });
        } else {
          qNotify.error({
            text: result.meta.message,
          });
          this.errors = result.meta.errors;
        }
      },
    });
  }

  public async approvalRepairRequest() {
    const result = await this.moveOutObject.approvalRepairRequest();
    if (result.meta.status === 200) {
      this.$router.replace({ query: { step: uuidv4() } });
      VueScrollTo.scrollTo({ force: true });
    } else {
      qNotify.error({
        text: result.meta.message,
      });
      this.errors = result.meta.errors;
    }
  }
}
